import { createFileRoute } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { Documentos } from '@/features/documentos/Documentos'

/**
 * Documentos e exportação.
 *
 * Rota clínica: tudo que sai daqui é prontuário decifrado, então ela fica
 * inteira dentro do `KeyGate`. Com a chave trancada não há nem lista de
 * paciente na tela.
 */
export const Route = createFileRoute('/_app/app/documentos')({
  staticData: { crumb: { label: 'Documentos' } },
  component: function DocumentosRoute() {
    return (
      <KeyGate>
        <Documentos />
      </KeyGate>
    )
  },
})
